
























































import {
  defineComponent,
  ref,
  PropType,
  computed,
  ComputedRef,
  onMounted,
} from '@vue/composition-api';
import {
  EpigraphicSign,
  EpigraphicWord,
  RemoveSignPayload,
  EditTextAction,
  EditorDiscourseWord,
  SearchSpellingResultRow,
} from '@oare/types';
import sl from '@/serviceLocator';
import ConnectDiscourseItem from '@/views/Texts/CollectionTexts/AddTexts/Discourse/components/ConnectDiscourseItem.vue';

export default defineComponent({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    word: {
      type: Object as PropType<EpigraphicWord>,
      required: true,
    },
    sign: {
      type: Object as PropType<EpigraphicSign>,
      required: true,
    },
    textUuid: {
      type: String,
      required: true,
    },
    line: {
      type: Number,
      required: true,
    },
    currentEditAction: {
      type: String as PropType<EditTextAction>,
      required: false,
    },
  },
  components: {
    ConnectDiscourseItem,
  },
  setup(props, { emit }) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const getUpdatedSignsWithSeparators = () => {
      const newSigns = props.word.signs.filter(
        sign => sign.uuid !== props.sign.uuid
      );
      const newWord = newSigns.map((sign, index) => {
        const nextSign =
          index !== newSigns.length - 1 ? newSigns[index + 1] : null;

        let newSeparator = '';
        if (nextSign) {
          if (
            !sign.markups
              .map(unit => unit.type)
              .includes('phoneticComplement') &&
            nextSign.markups
              .map(unit => unit.type)
              .includes('phoneticComplement')
          ) {
            newSeparator = '';
          } else if (
            sign.type === 'determinative' ||
            nextSign.type === 'determinative'
          ) {
            newSeparator = '';
          } else if (
            sign.type === 'phonogram' ||
            nextSign.type === 'phonogram'
          ) {
            newSeparator = '-';
          } else if (sign.type === 'number' && nextSign.type === 'number') {
            newSeparator = '+';
          } else if (sign.type === 'logogram' || nextSign.type === 'logogram') {
            newSeparator = '.';
          }
        }

        let newReading = sign.reading;
        if (sign.type === 'determinative') {
          newReading = `(${newReading})`;
        }

        return {
          ...sign,
          reading: newReading,
          separator: newSeparator,
        };
      });

      let newWordReading = '';
      newWord.forEach(sign => {
        newWordReading += sign.reading;
        if (sign.separator) {
          newWordReading += sign.separator;
        }
      });
      return newWordReading
        .replace(/([[\]{}⸢⸣«»‹›:;*?\\!])|(".+")|('.+')|(^\/)+/g, '')
        .replace(/<[^>]*>/g, '');
    };

    const removeSignLoading = ref(false);
    const removeSign = async () => {
      try {
        removeSignLoading.value = true;

        const newSpelling = getUpdatedSignsWithSeparators().replace(
          /<[^>]*>/g,
          ''
        );

        const payload: RemoveSignPayload = {
          type:
            props.currentEditAction === 'removeSign'
              ? 'removeSign'
              : 'removeUndeterminedSigns',
          textUuid: props.textUuid,
          uuid: props.sign.uuid,
          line: props.line,
          spellingUuid: form.value ? form.value.spellingUuid : null,
          transcription: form.value ? form.value.form.form : null,
          spelling: newSpelling,
        };
        await server.editText(payload);
        emit('reset-renderer');
      } catch (err) {
        actions.showErrorSnackbar(
          'Error removing sign. Please try again.',
          err as Error
        );
      } finally {
        emit('input', false);
        emit('reset-current-edit-action');
        removeSignLoading.value = false;
      }
    };

    const form = ref<SearchSpellingResultRow>();

    const editorDiscourseWord: ComputedRef<EditorDiscourseWord> = computed(
      () => {
        const newWord = getUpdatedSignsWithSeparators();
        return {
          discourseUuid: props.word.discourseUuid,
          spelling: newWord,
          type: 'word',
        };
      }
    );

    const formsLoaded = ref(false);
    onMounted(() => {
      if (props.word.signs.length === 1) {
        formsLoaded.value = true;
      }
    });

    return {
      getUpdatedSignsWithSeparators,
      removeSign,
      removeSignLoading,
      form,
      editorDiscourseWord,
      formsLoaded,
    };
  },
});
